module.exports = __webpack_public_path__ + "static/media/vnda22.3b879f94.png";